import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { MiscTasks } from '../api/relevant';
import { stores } from '../stores';

const HEARTBEAT_INTERVAL = 60 * 1000;

type ActiveUser = {
	id: string;
	email: string;
	fullname: string;
	initials: string;
	img?: string;
};

export function useHeartbeat() {
	const query = useQuery({
		queryKey: ['heartbeat', stores.identity.userId()],
		queryFn: async () => await MiscTasks.call('heartbeat', { noAccessLogging: true }) as ActiveUser[],
		refetchInterval: HEARTBEAT_INTERVAL,
		refetchIntervalInBackground: false,
		refetchOnMount: 'always',
		staleTime: HEARTBEAT_INTERVAL,
	});

	return query;
}
